<template>
  <div>
      <div style="text-align:center">
        <h1 class="title">千里眼监控平台</h1>
      </div>
      <el-form ref="params" :model="params" :rules="rules">
        <el-form-item prop="userName">
          <div class="login-tel login-input">
            <div class="bg-img"></div>
            <el-input id="userName"
              autocomplete="off"
              v-model="params.userName"
              placeholder="请输入手机号码"
              oninput="if(value.length>11)value=value.slice(0,11)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="userPass">
          <div class="login-password login-input">
            <div class="bg-img"></div>
            <el-input id="password"
              autocomplete="new-password"
              ref="password"
              type="password"
              onpaste="return false"
              oncontextmenu="return false"
              oncopy="return false"
              oncut="return false"
              oninput="if(value.length>20)value=value.slice(0,20)"
              v-model="params.userPass"
              placeholder="请输入密码"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button class="btn" type="success" id="login" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import { setLocalStorageItem } from "@/utils/localstorage/LocalstorageKit";
import loginApi from "@/api/LoginApi";
export default {
  name: "Login",
  data() {
    return {
      params: {
        userName: "",
        userPass: "",
        code: "",
      },
      rules: {
        userName: {
          required: true,
          validator: this.validPhone,
          trigger: "blur",
        },
        userPass: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.clickEnter(true);
  },
  methods: {
    validPhone(rule, value, callback) {
      console.log(value);
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;

      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    clickEnter() {
      let that = this;
      document.onkeydown = function (e) {
        let key = window.event.keyCode;
        if (key === 13) {
          that.login();
        }
      };
    },
    login() {
      this.$refs["params"].validate(async (valid) => {
        if (valid) {
          loginApi.login(this.params).then((resp) => {
            if (resp.state == "OK") {
              setLocalStorageItem("token", resp.data.token);
              let value = JSON.stringify(resp.data.userInfo);
              setLocalStorageItem("userInfo", value);
             
              window.location.href = "/home";
            } else {
              this.$errorMsg(resp.msg);
              this.params = {};
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style  scoped>
.el-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 10px;
}
.login-input {
  position: relative;
  width: 400px;
}
.bg-img {
  width: 26px;
  height: 26px;
  position: absolute;
  left: 20px;
  top: 63px;
  z-index: 999;
}
.login-tel > .bg-img {
  background: url("../../assets/home/phone.png") no-repeat;
}
.login-password > .bg-img {
  background: url("../../assets/home/password.png") no-repeat;
}
>>> input {
  padding-left: 55px;
  height: 54px;
  color: #333333;
  font-size: 18px;
  margin-top: 50px;
}
.el-form-item {
  margin-bottom: 0;
}
.btn {
  width: 400px;
  height: 64px;
  background: #98bc42;
  border-radius: 4px;
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: 50px;
}
</style>